window.Format = function () {
    var el = this;
    el.current = {};
    el.items = {};
    var template = $('#formats-template').html();

    el.init = function () {
        var availFormats = {};
        var formatId;

        el.calculator.init();

        if (!el.calculator.price.hasOwnProperty(el.calculator.priceGroupId)) {
            console.log('Не найдена группа цен на сувенирку у текущего адреса компании');
            return false;
        }

        if (!el.calculator.price[el.calculator.priceGroupId].hasOwnProperty(el.product.id)) {
            console.log('У компании не указана цена за продукцию ' + el.product.name);
            return false;
        }

        var price = el.calculator.price[el.calculator.priceGroupId][el.product.id];

        for (formatId in price) {
            if (formatId === '0') {
                continue;
            }

            availFormats[formatId] = el.items[formatId];
        }

        var id = 0;

        if (el.project.current.constructor.hasOwnProperty('workareas') && Object.keys(el.project.current.constructor.workareas).length > 0) {
            var workareaId = Object.keys(el.project.current.constructor.workareas)[0];
            id = el.project.current.constructor.workareas[workareaId].format.id;
        }

        if (!availFormats.hasOwnProperty(id) || id === 0) {
            id = Object.keys(availFormats)[0];
        }

        el.current = el.items[id];
    };

    el.render = function () {
        var templateData = {
            currency: el.calculator.currency,
            formats: []
        };

        var price = el.calculator.price[el.calculator.priceGroupId][el.product.id];

        var formatId, templateFormat;
        for (formatId in price) {
            if (formatId === '0') {
                continue;
            }

            templateFormat = $.extend(true, {}, el.items[formatId]);
            templateFormat.cost = el.calculator.getFormatCost(formatId);
            templateFormat.is_active = templateFormat.id === el.current.id ? true : false; 
            templateData.formats.push(templateFormat);
        }

        templateData.formats.sort(function (a, b) {
            if (parseInt(a.height) < parseInt(b.height)) {
                return -1;
            }

            if (parseInt(a.height) === parseInt(b.height) && parseInt(a.width) < parseInt(b.width)) {
                return -1;
            }

            if (parseInt(a.height) === parseInt(b.height) && parseInt(a.width) === parseInt(b.width)) {
                return 0;
            }

            return 1;
        });

        templateData.is_show = templateData.formats.length > 1 ? true : false;

        var html = el.templater.render(template, templateData);
        $('.formats').html(html);
    };

    el.set = function (id) {
        el.current = el.items[id];
        el.upImages.reset();
        el.workarea.setFormat(id);
        el.workarea.render();
        el.preview.update();
    };

    el.changeOrientation = function () {
        el.upImages.reset();
        el.workarea.rotateFormat();
        el.workarea.render();
        el.preview.update();
    };

    $(document).on('change', '.js-set-format', function () {
        el.set($(this).val());
    });

    $(document).on('click', '.js-change-orientation', function () {
        el.changeOrientation();
    });
};